<i18n
  src="@/locales/views/organization/partners/producers/list_producers.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/producer.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/crop_field.yml" lang="yaml"></i18n>

<template>
  <bread-crumbs :labels="[module_name]" />
  <template v-if="load_data_general">

    <tabs-container v-model="option_tabs" :with_routing="true" />

    <router-view
      :organization_id="organization_id"
    ></router-view>
  </template>
  <loading-message v-else />
</template>

<script>
export default {
  name: "OrgPartnersProducersListProducers",
  data() {
    return {
      load_data_general: false,
      option_tabs: [],
    };
  },
  props: {
    organization_id: {
      required: true
    }
  },
  methods: {
    fetchData: function(){
      this.fillOptions();
      this.load_data_general = true
    },

    fillOptions: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.formalized_active_title"),
          icon: "fa-solid fa-user-check",
          route: { name: this.routeName("list_producers_formalized_active") },
          current: true
        },
        {
          name: this.$t("labels.not_formalized_active_title"),
          icon: "fa-solid fa-user-minus",
          route: { name: this.routeName("list_producers_not_formalized_active") }
        },
        {
          name: this.$t("labels.inactive_title"),
          icon: "fa-solid fa-ban",
          route: { name: this.routeName("list_producers_inactive") }
        }
      ];
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => this.fetchData())
    );
  }
};
</script>
